// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".required[data-v-27ce4c98]:after{content:\" *\";color:red}.p-card[data-v-27ce4c98]{box-shadow:none}[data-v-27ce4c98] .p-dialog .p-card .p-card-body{padding:0!important}", ""]);
// Exports
module.exports = exports;
